import { render, staticRenderFns } from "./resource-calendar.vue?vue&type=template&id=155fbaae&scoped=true&"
import script from "./resource-calendar.ts?vue&type=script&lang=ts&"
export * from "./resource-calendar.ts?vue&type=script&lang=ts&"
import style0 from "./resource-calendar.scss?vue&type=style&index=0&id=155fbaae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155fbaae",
  null
  
)

export default component.exports